import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

type VisitDailyOverviewFastOrderFormSubtitleProps = {
  dateTime?: Date;
  endDateTime?: Date;
  firstName?: string;
  lastName?: string;
};

export const VisitDailyOverviewFastOrderFormSubtitle = ({
  dateTime,
  endDateTime,
  firstName,
  lastName,
}: VisitDailyOverviewFastOrderFormSubtitleProps) => {
  if (!dateTime) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {dayjs(dateTime).format('dddd, D. MMMM YYYY')}
      </Typography>
      <Typography variant="body2" fontWeight="bold" color="primary.main">
        {dayjs(dateTime).format('HH:mm')}
        {endDateTime && ` – ${dayjs(endDateTime).format('HH:mm')}`}
      </Typography>
      {lastName && (
        <Typography variant="body2" color="text.secondary">
          | {firstName} {lastName}
        </Typography>
      )}
    </Stack>
  );
};
